<template>
  <div class="crm-page">
    <div class="crm-hero">
      <div>
        <div class="crm-eyebrow">客户管理CRM</div>
        <h2>回访日历</h2>
        <p>
          支持月视图、周视图、列表视图演示，点击日期查看该天回访任务和高优先级客户安排。
        </p>
      </div>
      <div class="crm-actions">
        <el-radio-group v-model="viewMode" size="small">
          <el-radio-button label="month">月视图</el-radio-button>
          <el-radio-button label="week">周视图</el-radio-button>
          <el-radio-button label="list">列表视图</el-radio-button>
        </el-radio-group>
      </div>
    </div>

    <el-row :gutter="16">
      <el-col :span="viewMode === 'month' ? 16 : 24">
        <el-card shadow="never" v-if="viewMode === 'month'">
          <div slot="header">月视图</div>
          <el-calendar v-model="calendarDate">
            <template slot="dateCell" slot-scope="{ data }">
              <div class="date-cell" @click="selectDate(data.day)">
                <span>{{ data.day.slice(8) }}</span>
                <i v-if="eventCount(data.day)" class="event-dot"></i>
              </div>
            </template>
          </el-calendar>
        </el-card>

        <el-card shadow="never" v-else-if="viewMode === 'week'">
          <div slot="header">周视图</div>
          <div class="week-grid">
            <div v-for="item in weekEvents" :key="item.id" class="week-item">
              <div class="week-date">{{ item.date }}</div>
              <div class="week-name">{{ item.customerName }}</div>
              <el-tag
                size="mini"
                :type="item.priority === '高' ? 'danger' : 'warning'"
                >{{ item.type }}</el-tag
              >
            </div>
          </div>
        </el-card>

        <el-card shadow="never" v-else>
          <div slot="header">列表视图</div>
          <el-table :data="events" stripe border>
            <el-table-column
              prop="date"
              label="日期"
              min-width="110"
            ></el-table-column>
            <el-table-column
              prop="customerName"
              label="客户姓名"
              min-width="120"
            ></el-table-column>
            <el-table-column
              prop="type"
              label="任务类型"
              min-width="120"
            ></el-table-column>
            <el-table-column prop="priority" label="优先级" width="90">
              <template slot-scope="scope">
                <el-tag
                  size="mini"
                  :type="scope.row.priority === '高' ? 'danger' : 'warning'"
                  >{{ scope.row.priority }}</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button type="text" @click="jumpCustomer(scope.row)"
                  >查看客户</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>

      <el-col v-if="viewMode === 'month'" :span="8">
        <el-card shadow="never">
          <div slot="header">当日任务</div>
          <div class="day-list">
            <div
              v-for="item in selectedDateEvents"
              :key="item.id"
              class="day-item"
            >
              <div>
                <div class="day-title">{{ item.customerName }}</div>
                <div class="day-meta">{{ item.type }}</div>
              </div>
              <el-tag
                size="mini"
                :type="item.priority === '高' ? 'danger' : 'warning'"
                >{{ item.priority }}</el-tag
              >
            </div>
            <el-empty
              v-if="!selectedDateEvents.length"
              description="该日期暂无任务"
            ></el-empty>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { loadCrmState } from "./mock";

export default {
  name: "CrmCalendar",
  data() {
    return {
      state: loadCrmState(this.$store.getters.GET_TITLE || "当前员工"),
      viewMode: "month",
      calendarDate: new Date(),
      selectedDate: "2026-03-18",
    };
  },
  computed: {
    events() {
      return this.state.calendarEvents || [];
    },
    selectedDateEvents() {
      return this.events.filter((item) => item.date === this.selectedDate);
    },
    weekEvents() {
      return this.events.slice(0, 7);
    },
  },
  methods: {
    eventCount(day) {
      return this.events.filter((item) => item.date === day).length;
    },
    selectDate(day) {
      this.selectedDate = day;
    },
    jumpCustomer(event) {
      this.$message.success(
        `已定位到客户 ${event.customerName} 的回访任务（前端演示）`
      );
    },
  },
};
</script>

<style scoped>
.crm-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.crm-hero {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  padding: 24px 28px;
  border-radius: 18px;
  background: #fff;
  border: 1px solid #e8edf5;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.04);
}
.crm-eyebrow {
  display: inline-flex;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(64, 158, 255, 0.12);
  color: #409eff;
  font-size: 12px;
  font-weight: 700;
}
.crm-hero h2 {
  margin: 12px 0 0;
  font-size: 28px;
  color: #111827;
}
.crm-hero p {
  margin: 10px 0 0;
  color: #6b7280;
  line-height: 1.7;
}
.crm-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.date-cell {
  position: relative;
  height: 100%;
}
.event-dot {
  position: absolute;
  right: 6px;
  top: 4px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ef4444;
}
.day-list,
.week-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.day-item,
.week-item {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: center;
  padding: 12px 14px;
  border-radius: 14px;
  background: #f8fbff;
  border: 1px solid #e8edf5;
}
.day-title,
.week-name {
  font-weight: 700;
  color: #111827;
}
.day-meta,
.week-date {
  margin-top: 4px;
  color: #6b7280;
  font-size: 12px;
}
@media (max-width: 1200px) {
  .crm-hero {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
